$(document).ready(function(){
   var v2TotalVal = 0;
  $('.v2_offer').each(function() {
    let currentV2Val = parseFloat($(this).val()) || 0;
    v2TotalVal += currentV2Val;
    console.log("Current:", currentV2Val);
  });
  if(v2TotalVal == 3){
    // alert("show");
    setTimeout(function(){
      $('.v2_offer_cart_popup_main_outer').fadeIn(500, function() {
        $('body').addClass('scroll_stop');
      });
    },2000);
    
  }
  console.log("Total:", v2TotalVal);
  $('.v2_offer_cart_popup_inner .close').click(function(){
     $('.v2_offer_cart_popup_main_outer').fadeOut(500,function() {
        $('body').removeClass('scroll_stop');
      });
  });
});